import React from 'react';

const DashboardWelcomePage = () => {
    return (
        <div className='h-[850px] flex flex-col justify-center items-center bg-violet-200'>
            <h2 className='rounded-xl text-center text-3xl md:text-5xl lg:text-8xl text-indigo-500 font-bold bg-blue-300 px-16 py-5'>Welcome to Dashboard</h2>
        </div>
    );
};

export default DashboardWelcomePage;